import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useAppConfiguration } from "core/context/AppConfigurationContext";

export function ApplicationConfigurationErrorPage({
  message,
  supportEmail,
}: {
  message: string;
  supportEmail: string;
}) {
  return (
    <Container maxWidth="lg" sx={{ height: "100vh" }}>
      <Stack height="100%" gap={16} alignItems="center" justifyContent="center">
        <Box>
          <Typography
            textAlign="center"
            variant="h3"
            marginBottom={2}
            sx={{ overflowWrap: "anywhere" }}
          >
            {message}
          </Typography>
          <Typography textAlign="center" variant="h5">
            The error has been logged. Please refresh the page, or contact{" "}
            <a href={`mailto:${supportEmail ?? ""}`}>{supportEmail ?? ""}</a>
          </Typography>
        </Box>
      </Stack>
    </Container>
  );
}

export function ContextAwareApplicationConfigurationErrorPage({
  message,
}: {
  message: string;
}) {
  const config = useAppConfiguration();
  if (!config?.SUPPORT_EMAIL) {
    throw new Error("Support email is not configured");
  }
  return (
    <ApplicationConfigurationErrorPage
      message={message}
      supportEmail={config?.SUPPORT_EMAIL}
    />
  );
}
